module.exports = __webpack_public_path__ + "img/គីណូ.54755bf6.png";